// extracted by mini-css-extract-plugin
module.exports = {"signout":"header_signout__oO4Mx","signout__text":"header_signout__text__1Z9Y3"};